"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import Image from "next/image";
import { motion, useReducedMotion } from "framer-motion";
import { FaChevronRight } from "react-icons/fa";
import GradientButton from "@/components/ui/GradientButton";
import { shopifyHiringSteps, ShopifyHiringStep } from "./shopify.data";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
interface ShopifyFiveStepsProps {
  heading?: string;
  description?: string;
  steps?: ShopifyHiringStep[];
  imageSrc?: string;
  imageAlt?: string;
  buttonText?: string;
  buttonHref?: string;
  className?: string;
}
export default function ShopifyFiveSteps(t0) {
  const $ = _c(63);
  const {
    heading: t1,
    description: t2,
    steps: t3,
    imageSrc: t4,
    imageAlt: t5,
    buttonText: t6,
    buttonHref: t7,
    className: t8
  } = t0;
  const heading = t1 === undefined ? "Five Steps to Hire Shopify Developers" : t1;
  const description = t2 === undefined ? "Do you want to start your eCommerce business through Shopify? Hiring Shopify developers from The Dezine is easy to make your eCommerce business journey smoother. We help you make the right hiring decisions with our simple hiring process. The 5-step short hiring process makes it easier for business owners to pick the perfect developers for their project needs. Hire remote Shopify programmers and coders in a few steps and at flexible models." : t2;
  const steps = t3 === undefined ? shopifyHiringSteps : t3;
  const imageSrc = t4 === undefined ? "/images/crm/how-it-works.png" : t4;
  const imageAlt = t5 === undefined ? "Five Steps to Hire Shopify Developers" : t5;
  const buttonText = t6 === undefined ? "Contact Us" : t6;
  const buttonHref = t7 === undefined ? "/contact" : t7;
  const className = t8 === undefined ? "" : t8;
  const desktopAnimations = useDesktopAnimations();
  useReducedMotion();
  const t9 = `relative overflow-hidden bg-white py-16 font-sans transition-colors duration-300 sm:py-20 lg:py-24 dark:bg-[#070b14] ${className}`;
  let t10;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="pointer-events-none absolute inset-0 opacity-40 bg-[radial-gradient(circle,rgba(75,88,125,.18)_0.8px,transparent_0.9px)] bg-[length:12px_12px]" aria-hidden="true" />;
    $[0] = t10;
  } else {
    t10 = $[0];
  }
  let t11;
  if ($[1] !== desktopAnimations) {
    t11 = desktopAnimations ? {
      opacity: 0,
      y: 30
    } : false;
    $[1] = desktopAnimations;
    $[2] = t11;
  } else {
    t11 = $[2];
  }
  let t12;
  if ($[3] !== desktopAnimations) {
    t12 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[3] = desktopAnimations;
    $[4] = t12;
  } else {
    t12 = $[4];
  }
  let t13;
  if ($[5] !== desktopAnimations) {
    t13 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[5] = desktopAnimations;
    $[6] = t13;
  } else {
    t13 = $[6];
  }
  let t14;
  let t15;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      once: true
    };
    t15 = {
      duration: 0.7,
      ease
    };
    $[7] = t14;
    $[8] = t15;
  } else {
    t14 = $[7];
    t15 = $[8];
  }
  let t16;
  if ($[9] !== heading) {
    t16 = <h2 className="font-poppins text-[30px] font-bold leading-[1.2] text-[#0b1354] sm:text-[38px] lg:text-[44px] dark:text-white">{heading}</h2>;
    $[9] = heading;
    $[10] = t16;
  } else {
    t16 = $[10];
  }
  let t17;
  if ($[11] !== description) {
    t17 = <p className="font-sans mt-5 text-[15px] leading-[28px] text-[#5e6282] sm:text-[16px] dark:text-gray-300">{description}</p>;
    $[11] = description;
    $[12] = t17;
  } else {
    t17 = $[12];
  }
  let t18;
  if ($[13] !== buttonHref || $[14] !== buttonText) {
    t18 = buttonText && <div className="mt-8 flex justify-center lg:justify-start"><GradientButton href={buttonHref} variant="pink-purple" className=""><span>{buttonText}</span><FaChevronRight className="ml-1 text-[12px]" /></GradientButton></div>;
    $[13] = buttonHref;
    $[14] = buttonText;
    $[15] = t18;
  } else {
    t18 = $[15];
  }
  let t19;
  if ($[16] !== t11 || $[17] !== t12 || $[18] !== t13 || $[19] !== t16 || $[20] !== t17 || $[21] !== t18) {
    t19 = <motion.div initial={t11} whileInView={t12} animate={t13} viewport={t14} transition={t15}>{t16}{t17}{t18}</motion.div>;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
    $[19] = t16;
    $[20] = t17;
    $[21] = t18;
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  let t20;
  if ($[23] !== desktopAnimations) {
    t20 = desktopAnimations ? {
      opacity: 0,
      scale: 0.95
    } : false;
    $[23] = desktopAnimations;
    $[24] = t20;
  } else {
    t20 = $[24];
  }
  let t21;
  if ($[25] !== desktopAnimations) {
    t21 = desktopAnimations ? {
      opacity: 1,
      scale: 1
    } : undefined;
    $[25] = desktopAnimations;
    $[26] = t21;
  } else {
    t21 = $[26];
  }
  let t22;
  if ($[27] !== desktopAnimations) {
    t22 = desktopAnimations ? undefined : {
      opacity: 1,
      scale: 1
    };
    $[27] = desktopAnimations;
    $[28] = t22;
  } else {
    t22 = $[28];
  }
  let t23;
  let t24;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = {
      once: true
    };
    t24 = {
      duration: 0.8,
      delay: 0.2,
      ease
    };
    $[29] = t23;
    $[30] = t24;
  } else {
    t23 = $[29];
    t24 = $[30];
  }
  let t25;
  if ($[31] !== desktopAnimations) {
    t25 = desktopAnimations ? {
      y: [0, -12, 0]
    } : undefined;
    $[31] = desktopAnimations;
    $[32] = t25;
  } else {
    t25 = $[32];
  }
  let t26;
  if ($[33] !== desktopAnimations) {
    t26 = desktopAnimations ? {
      duration: 4.5,
      repeat: Infinity,
      ease: "easeInOut"
    } : undefined;
    $[33] = desktopAnimations;
    $[34] = t26;
  } else {
    t26 = $[34];
  }
  let t27;
  if ($[35] !== imageAlt || $[36] !== imageSrc) {
    t27 = <Image src={imageSrc} alt={imageAlt} width={420} height={420} className="h-auto w-full max-w-[420px] object-contain" onError={_temp} />;
    $[35] = imageAlt;
    $[36] = imageSrc;
    $[37] = t27;
  } else {
    t27 = $[37];
  }
  let t28;
  if ($[38] !== t25 || $[39] !== t26 || $[40] !== t27) {
    t28 = <motion.div animate={t25} transition={t26}>{t27}</motion.div>;
    $[38] = t25;
    $[39] = t26;
    $[40] = t27;
    $[41] = t28;
  } else {
    t28 = $[41];
  }
  let t29;
  if ($[42] !== t20 || $[43] !== t21 || $[44] !== t22 || $[45] !== t28) {
    t29 = <motion.div initial={t20} whileInView={t21} animate={t22} viewport={t23} transition={t24} className="mt-10 flex justify-center lg:justify-start">{t28}</motion.div>;
    $[42] = t20;
    $[43] = t21;
    $[44] = t22;
    $[45] = t28;
    $[46] = t29;
  } else {
    t29 = $[46];
  }
  let t30;
  if ($[47] !== t19 || $[48] !== t29) {
    t30 = <div className="flex flex-col justify-center text-center lg:col-span-6 lg:text-left">{t19}{t29}</div>;
    $[47] = t19;
    $[48] = t29;
    $[49] = t30;
  } else {
    t30 = $[49];
  }
  let t31;
  if ($[50] !== desktopAnimations || $[51] !== steps) {
    let t32;
    if ($[53] !== desktopAnimations) {
      t32 = (item, idx) => <motion.div key={item.id} initial={desktopAnimations ? {
        opacity: 0,
        x: 35
      } : false} whileInView={desktopAnimations ? {
        opacity: 1,
        x: 0
      } : undefined} animate={desktopAnimations ? undefined : {
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.55,
        delay: idx * 0.1,
        ease
      }} className="h-full"><article className="group relative ml-4 flex items-center gap-5 rounded-[16px] border border-gray-100/90 bg-white py-5 pl-10 pr-6 shadow-[0_8px_30px_rgba(20,50,90,0.06)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_14px_36px_rgba(20,50,90,0.1)] dark:border-gray-800 dark:bg-gray-900"><div className="absolute -left-4 top-1/2 z-10 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full border border-[#f6248c] bg-white font-poppins text-[14px] font-bold text-[#0b1354] shadow-sm dark:bg-gray-900 dark:text-white"><span>{item.step}</span></div><div className="flex h-14 w-14 shrink-0 items-center justify-center"><Image src={item.icon} alt={item.alt} width={56} height={56} loading="lazy" className="h-full w-full object-contain" onError={e_0 => {
              e_0.currentTarget.src = `/images/crm/why-${item.step}.png`;
            }} /></div><div className="min-w-0 flex-1"><h3 className="font-poppins mb-1 text-[17px] font-bold leading-snug text-[#0b1354] sm:text-[18px] dark:text-white">{item.title}</h3><p className="font-sans text-[13.5px] leading-relaxed text-[#6c757d] sm:text-[14px] dark:text-gray-400">{item.description}</p></div></article></motion.div>;
      $[53] = desktopAnimations;
      $[54] = t32;
    } else {
      t32 = $[54];
    }
    t31 = steps.map(t32);
    $[50] = desktopAnimations;
    $[51] = steps;
    $[52] = t31;
  } else {
    t31 = $[52];
  }
  let t32;
  if ($[55] !== t31) {
    t32 = <div className="relative flex flex-col gap-5 pl-3 sm:gap-6 sm:pl-6 lg:col-span-6">{t31}</div>;
    $[55] = t31;
    $[56] = t32;
  } else {
    t32 = $[56];
  }
  let t33;
  if ($[57] !== t30 || $[58] !== t32) {
    t33 = <div className="relative z-10 mx-auto w-full max-w-[1280px] px-4 sm:px-6 lg:px-8"><div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-14">{t30}{t32}</div></div>;
    $[57] = t30;
    $[58] = t32;
    $[59] = t33;
  } else {
    t33 = $[59];
  }
  let t34;
  if ($[60] !== t33 || $[61] !== t9) {
    t34 = <section className={t9}>{t10}{t33}</section>;
    $[60] = t33;
    $[61] = t9;
    $[62] = t34;
  } else {
    t34 = $[62];
  }
  return t34;
}
function _temp(e) {
  e.currentTarget.src = "/images/crm/why-choose.png";
}